import { render, staticRenderFns } from "./CodeInput.vue?vue&type=template&id=5aaf7d33&scoped=true"
import script from "./CodeInput.vue?vue&type=script&lang=js"
export * from "./CodeInput.vue?vue&type=script&lang=js"
import style0 from "./CodeInput.vue?vue&type=style&index=0&id=5aaf7d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf7d33",
  null
  
)

export default component.exports